module.exports = __webpack_public_path__ + "media/images/medicina-c8b4edc77dbe9343ba122da5373ac824.svg";